import View from './View';

export { default as View } from './View';
export default View;